module.exports = __webpack_public_path__ + "assets/media/npr20160621.ae6e18a.mp3";